module.exports = __webpack_public_path__ + "c637cdc45040efa4bd0155d03f844bc2.ttf";